import { render, staticRenderFns } from "./BasePhoneRow.vue?vue&type=template&id=0e3c14b9"
import script from "./BasePhoneRow.vue?vue&type=script&lang=js"
export * from "./BasePhoneRow.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneRow.vue?vue&type=style&index=0&id=0e3c14b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports